module.exports = __webpack_public_path__ + "img/miladcontrole.86ed7b33.jpg";